import Instance from "./instance";

export const createMessage = async (payload) => {
  return await Instance.instance.post("contact",payload);
};